<template>
  <div class="gs-wizard-card gs-domains-tab">
    <div class="gs-domains-tab__header">
      <h2>{{ $t('groovesell_vendor_settings_manage_domains') }}</h2>
      <gs-button variant="outline" size="md" @click="editDomains">
        {{ $t('groovesell_vendor_settings_goto_domains') }}
      </gs-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    editDomains() {
      this.$root.$emit('open-account-modal', this.$t('frontend_sites_account_modal_domains'));
    },
  },
}
</script>

<style>
.gs-domains-tab__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.gs-domains-tab__header > h2 {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}
</style>
